export default __webpack_public_path__ + "static/media/example-tesla-IMG.cd53cbd1.jpg";